module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"PHU HUMAJ","short_name":"HUMAJ","description":"Skup i sprzedaż złomu stalowego, metali kolorowych oraz wyrobów hutniczych. Transport i przetwórstwo.","start_url":"/","background_color":"#0a1428","theme_color":"#1a2744","display":"standalone","lang":"pl","icon":"src/images/icon.png","icon_options":{"purpose":"any maskable"},"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"d01c47006d9b1addcc1a7b78f717e0c5"},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
